<template>
<div>
<b-navbar toggleable="lg" type="light" variant="default" class="fixed-top navbar-light bg-light">
    <b-container>
    <img src="../assets/logo.png" fluid width="40px"/>
    <b-navbar-brand href="#" :to="{ path: '/'}">FMT-DB</b-navbar-brand>

    <b-navbar-toggle target="nav_collapse" />

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item class="nav-link" to="/pairbrowser">Browse</b-nav-item>
        <b-nav-item class="nav-link" to="/speciesgenusbrowse">Species</b-nav-item>
        <b-nav-item class="nav-link" to="/data">Data</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <vue-bootstrap-typeahead
          placeholder="Search here" 
          v-model="quer"
          :data="querRes"
          :serializer="item => item.index"
          minMatchingChars:3
          @hit="searchMe($event)"
          class="specialTb"
        >
        <template slot="suggestion" slot-scope="{ data, htmlText }">
              <span v-html="htmlText"></span>&nbsp;<small> <b></b>[ {{ data.type }} ]</small>
        </template>
        </vue-bootstrap-typeahead>
      <!-- <b-input-group  class="mt-3">
        <b-form-input size="sm"  placeholder="Search"></b-form-input>
        <b-input-group-append>
          <b-button size="sm" variant="outline-success" ><font-awesome-icon icon="search" ></font-awesome-icon></b-button>
        </b-input-group-append>
      </b-input-group> -->
      </b-navbar-nav>
    </b-collapse>
    </b-container>
  </b-navbar>
  </div>
</template>

<script>
import EventBus from './EventBus'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import axios from 'axios'

export default {
    components:{
      VueBootstrapTypeahead
    },
    data () {
        return {
          server_add : this.$hostname,
          auth: '',
          user: '',
          email: '',
          log_check_status: '',
          password: '',
          quer: '',
          selectedquery: null,
          querRes: [],
        }
    },
    methods: {
      searchMe(serKey){
        if(serKey.type === 'species'){
           let route = this.$router.resolve({path: '/viewpair/sp/'+serKey.index})
           window.open(route.href, '_blank');
        }else if(serKey.type === 'genus'){
          let route = this.$router.resolve({path: '/viewpair/gen/'+serKey.index})
          window.open(route.href, '_blank');
        }else if(serKey.type === 'hmPair'){
          var tem = serKey.index.replace(":","/")
          let route = this.$router.resolve({path: '/viewpair/p/'+tem})
          window.open(route.href, '_blank');
        }
      }
    },
    created() {
      EventBus.$on('logged-in', status => {
        if(status=='100' || status=='101'){
          this.auth = 'loggedin'
        }else{
          this.auth = ''
        }
      })
    },
    watch: {
      quer(newQuery) {
      axios.get(`${this.server_add}query/searchSug?query=${newQuery}`)
        .then((res) => {
          this.querRes = res.data.items
        })
      }
    },
}
</script>

<style >
.specialTb
{
    width:100%;
    align-self: center;
     margin: 0 auto;
}
</style>